// extracted by mini-css-extract-plugin
export default {"productGrid":"H0-z","centerLink":"I0-z","productSection":"J0-z","item":"K0-z","ctaButton":"L0-z"};